import { NavLink } from "react-router-dom";
import NavbarButton from "./NavbarButton";

type NavLinkBtnProps = {
  path: string;
  iconSize: number;
  Icon: any;
  IconOutline: any;
  title: string;
};

export const NavLinkBtn = ({ path, iconSize, Icon, IconOutline, title }: NavLinkBtnProps) => {
  return (
    <NavLink to={path}>
      {({ isActive }) => (
        <NavbarButton
          icon={
            isActive ? (
              <Icon width={iconSize} height={iconSize} />
            ) : (
              <IconOutline width={iconSize} height={iconSize} />
            )
          }
          title={title}
          isActive={isActive}
        />
      )}
    </NavLink>
  );
};
